module.exports = __webpack_public_path__ + "img/3.3.1f0c6110.png";